module.exports = __webpack_public_path__ + "img/ITSystems_w.4f94900d.png";